import {h} from "preact";
import useFormStore from '../../store/useFormStore';

export default function BackButton({ text = "Back", onBack, className = "coit-button", showIcon = true }) {
  const goToPreviousScreen = useFormStore((state) => state.goToPreviousScreen);

  const handleClick = () => {
    if (onBack) {
      onBack();
    } else {
      goToPreviousScreen();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${className} ${showIcon ? 'flex items-center gap-1' : ''}`}
    >
      {showIcon && (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      )}
      <span>{text}</span>
    </button>
  );
}
